import { makeStyles } from "@material-ui/styles";
// eslint-disable-next-line import/named
import { Theme } from '@material-ui/core';

export const useStyles = makeStyles<Theme>(theme => ({
    root: {
        width: "100%",
        height: "100%",
        zIndex: 1,
    },
    appFrame: {
        position: "relative",
        display: "flex",
        width: "100%",
        height: "100%",
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,       
        background: "white"
    },
    navIconHide: {
        [theme.breakpoints.up("md")]: {
            display: "none",
        },
    },
    content: {
        //backgroundColor: theme.palette.background.default,
        width: "100%",
        height: "calc(100% - 56px)",
        marginTop: 56,
        [theme.breakpoints.up("sm")]: {
            height: "calc(100% - 80px)",
            marginTop: 80,
        },
    },
    toolbar: {
        minHeight: 'auto',
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        textAlign: "center",
        alignItems: "center",
        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-middle",


        },
    },
    logo: { width: 150 },
    menuButtons: {
        display: "none",
        flexDirection: "row",
        [theme.breakpoints.up("md")]: {
            flexDirection: "row",
            display: "flex",

        },
    },
    item: {
        textAlign: 'center',
        padding: theme.spacing(1),
        color: '#727272',
        cursor: 'pointer',
        [theme.breakpoints.up("md")]: {
            paddingLeft: theme.spacing(3),

        },
    },
}))